<template>
  <div class="lp">
    <!-- NAV -->
    <header class="lp-nav" :class="{ 'is-scrolled': scrolled }">
      <div class="lp-nav__inner">
        <a href="#top" class="lp-brand" @click.prevent="scrollTo('top')">
          <span class="lp-brand__mark" aria-hidden="true"></span>
          <span class="lp-brand__name">SenderWA</span>
        </a>
        <nav class="lp-nav__links" v-show="!isMobile">
          <a href="#fitur" @click.prevent="scrollTo('fitur')">Fitur</a>
          <a href="#cara-kerja" @click.prevent="scrollTo('cara-kerja')">Cara Kerja</a>
          <a href="#harga" @click.prevent="scrollTo('harga')">Harga</a>
          <a href="#api" @click.prevent="scrollTo('api')">API</a>
        </nav>
        <div class="lp-nav__actions">
          <router-link to="/login" class="lp-link-quiet">Masuk</router-link>
          <router-link to="/registrasi-user" class="lp-btn lp-btn--nav">
            Coba Gratis
          </router-link>
        </div>
      </div>
    </header>

    <!-- HERO -->
    <section id="top" class="lp-hero">
      <div class="lp-hero__bg" aria-hidden="true">
        <div class="lp-hero__wash"></div>
        <div class="lp-hero__signal"></div>
        <svg class="lp-hero__grid" viewBox="0 0 1200 800" preserveAspectRatio="xMidYMid slice">
          <defs>
            <linearGradient id="g1" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stop-color="#8fd6b5" stop-opacity="0.35" />
              <stop offset="100%" stop-color="#1f7a57" stop-opacity="0" />
            </linearGradient>
          </defs>
          <circle cx="920" cy="220" r="280" fill="url(#g1)" />
          <path
            d="M80 620 C280 480, 420 720, 640 540 S980 380, 1180 520"
            fill="none"
            stroke="rgba(143,214,181,0.22)"
            stroke-width="2"
          />
          <path
            d="M40 680 C260 540, 400 760, 620 580 S960 420, 1200 560"
            fill="none"
            stroke="rgba(143,214,181,0.12)"
            stroke-width="2"
          />
        </svg>
        <div class="lp-hero__device" aria-hidden="true">
          <div class="lp-phone">
            <div class="lp-phone__notch"></div>
            <div class="lp-phone__screen">
              <div class="lp-bubble lp-bubble--in">Pesanan #1042 sudah dikirim</div>
              <div class="lp-bubble lp-bubble--out">OTP: 849201</div>
              <div class="lp-bubble lp-bubble--in">Terima kasih, sudah masuk</div>
              <div class="lp-bubble lp-bubble--out lp-bubble--typing">
                <span></span><span></span><span></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="lp-hero__content">
        <div class="lp-brand-hero">SenderWA</div>
        <h1 class="lp-hero__title">
          Gateway WhatsApp untuk bisnis yang butuh kirim pesan andal
        </h1>
        <p class="lp-hero__lead">
          Kirim notifikasi, OTP, dan broadcast lewat API atau dashboard — multi nomor, terjadwal, dan auto reply.
        </p>
        <div class="lp-hero__cta">
          <router-link to="/registrasi-user" class="lp-btn lp-btn--primary">
            Mulai Sekarang
          </router-link>
          <router-link to="/login" class="lp-btn lp-btn--ghost">
            Masuk Dashboard
          </router-link>
        </div>
      </div>
    </section>

    <!-- FITUR -->
    <section id="fitur" class="lp-section">
      <div class="lp-section__inner">
        <p class="lp-eyebrow">Yang Anda dapatkan</p>
        <h2 class="lp-h2">Infrastruktur pesan WhatsApp siap produksi</h2>
        <p class="lp-lead">
          Fokus ke bisnis Anda — pengiriman, antrian, dan sesi nomor kami yang tangani.
        </p>

        <div class="lp-features">
          <article
            v-for="(item, i) in features"
            :key="item.title"
            class="lp-feature"
            :style="{ '--i': i }"
          >
            <div class="lp-feature__icon" aria-hidden="true">
              <v-icon>{{ item.icon }}</v-icon>
            </div>
            <h3>{{ item.title }}</h3>
            <p>{{ item.text }}</p>
          </article>
        </div>
      </div>
    </section>

    <!-- CARA KERJA -->
    <section id="cara-kerja" class="lp-section lp-section--fog">
      <div class="lp-section__inner">
        <p class="lp-eyebrow">Cara kerja</p>
        <h2 class="lp-h2">Tiga langkah ke pesan pertama</h2>
        <p class="lp-lead">
          Dari daftar akun sampai pesan terkirim — tanpa setup server yang rumit.
        </p>

        <ol class="lp-steps">
          <li v-for="(step, i) in steps" :key="step.title">
            <span class="lp-steps__num">{{ i + 1 }}</span>
            <div>
              <h3>{{ step.title }}</h3>
              <p>{{ step.text }}</p>
            </div>
          </li>
        </ol>
      </div>
    </section>

    <!-- HARGA -->
    <section id="harga" class="lp-section">
      <div class="lp-section__inner">
        <p class="lp-eyebrow">Paket harga</p>
        <h2 class="lp-h2">Pilih skala yang cocok untuk Anda</h2>
        <p class="lp-lead">
          Setiap paket mengatur jumlah nomor WhatsApp dan jenis pesan yang bisa dikirim.
        </p>

        <div v-if="paketsLoading" class="lp-pricing__state">Memuat paket…</div>
        <div v-else-if="!pakets.length" class="lp-pricing__state">
          Paket belum tersedia. Hubungi admin untuk informasi berlangganan.
        </div>
        <div v-else class="lp-pricing">
          <article
            v-for="(paket, i) in pakets"
            :key="paket.id"
            class="lp-price"
            :class="{ 'is-featured': isFeaturedPaket(i) }"
            :style="{ '--i': i }"
          >
            <div class="lp-price__badge" v-if="isFeaturedPaket(i)">Populer</div>
            <h3 class="lp-price__name">{{ paket.name }}</h3>
            <p class="lp-price__desc">
              {{ paket.description || 'Paket pengiriman WhatsApp' }}
            </p>
            <div class="lp-price__amount">
              <span class="lp-price__currency">Rp</span>
              <span class="lp-price__value">{{ formatPriceNumber(paket.price) }}</span>
            </div>
            <ul class="lp-price__features">
              <li>
                <v-icon small>mdi-cellphone-wireless</v-icon>
                {{ paket.max_wa || 1 }} nomor WhatsApp
              </li>
              <li :class="{ 'is-off': !paket.allow_text }">
                <v-icon small>{{ paket.allow_text ? 'mdi-check' : 'mdi-close' }}</v-icon>
                Kirim pesan teks
              </li>
              <li :class="{ 'is-off': !paket.allow_image }">
                <v-icon small>{{ paket.allow_image ? 'mdi-check' : 'mdi-close' }}</v-icon>
                Kirim pesan gambar
              </li>
              <li :class="{ 'is-off': !paket.allow_document }">
                <v-icon small>{{ paket.allow_document ? 'mdi-check' : 'mdi-close' }}</v-icon>
                Kirim dokumen / file
              </li>
            </ul>
            <router-link
              to="/registrasi-user"
              class="lp-btn"
              :class="isFeaturedPaket(i) ? 'lp-btn--primary' : 'lp-btn--outline'"
            >
              Pilih paket
            </router-link>
          </article>
        </div>
      </div>
    </section>

    <!-- API -->
    <section id="api" class="lp-section">
      <div class="lp-section__inner lp-api">
        <div class="lp-api__copy">
          <p class="lp-eyebrow">Untuk developer</p>
          <h2 class="lp-h2">API sederhana, integrasi cepat</h2>
          <p class="lp-lead">
            Kirim pesan dari aplikasi Anda dengan API key. Cocok untuk OTP, status pesanan, dan notifikasi sistem.
          </p>
          <ul class="lp-checklist">
            <li>Endpoint kirim teks, gambar &amp; dokumen</li>
            <li>Antrian &amp; status terkirim</li>
            <li>Multi nomor per akun</li>
          </ul>
        </div>
        <div class="lp-api__panel" aria-hidden="true">
          <div class="lp-code">
            <div class="lp-code__bar">
              <span></span><span></span><span></span>
              <em>POST /api/v2/send</em>
            </div>
            <pre><code>curl -X POST {{ apiHost }}/api/v2/send \
  -H "x-api-key: YOUR_KEY" \
  -d '{
    "phone": "62812xxxxxxx",
    "message": "Kode OTP Anda: 849201"
  }'</code></pre>
          </div>
        </div>
      </div>
    </section>

    <!-- USE CASES -->
    <section class="lp-section lp-section--fog">
      <div class="lp-section__inner">
        <p class="lp-eyebrow">Dipakai untuk</p>
        <h2 class="lp-h2">Satu gateway, banyak kebutuhan bisnis</h2>
        <div class="lp-uses">
          <div v-for="use in uses" :key="use" class="lp-use">{{ use }}</div>
        </div>
      </div>
    </section>

    <!-- CTA -->
    <section class="lp-cta">
      <div class="lp-cta__inner">
        <h2>Siap kirim pesan WhatsApp tanpa ribet?</h2>
        <p>
          Buat akun, hubungkan nomor, dan mulai dari dashboard atau API dalam hitungan menit.
        </p>
        <div class="lp-hero__cta">
          <router-link to="/registrasi-user" class="lp-btn lp-btn--primary">
            Daftar Sekarang
          </router-link>
          <router-link to="/login" class="lp-btn lp-btn--ghost-light">
            Sudah punya akun
          </router-link>
        </div>
      </div>
    </section>

    <footer class="lp-footer">
      <div class="lp-footer__inner">
        <div class="lp-brand">
          <span class="lp-brand__mark" aria-hidden="true"></span>
          <span class="lp-brand__name">SenderWA</span>
        </div>
        <p>WhatsApp Gateway untuk notifikasi, OTP, dan broadcast bisnis.</p>
        <div class="lp-footer__meta">
          <span>© {{ year }} SenderWA</span>
          <router-link to="/login">Masuk</router-link>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "LandingPage",
  data: () => ({
    scrolled: false,
    pakets: [],
    paketsLoading: true,
    features: [
      {
        icon: "mdi-api",
        title: "API & Dashboard",
        text: "Kirim lewat REST API atau antarmuka admin — sama-sama masuk antrian yang terukur.",
      },
      {
        icon: "mdi-cellphone-wireless",
        title: "Multi nomor",
        text: "Kelola beberapa sesi WhatsApp dalam satu akun, pilih pengirim per pesan.",
      },
      {
        icon: "mdi-calendar-clock",
        title: "Jadwal kirim",
        text: "Atur pengiriman di waktu terbaik — promo, reminder, atau follow-up otomatis.",
      },
      {
        icon: "mdi-reply-all-outline",
        title: "Auto reply",
        text: "Balas keyword masuk secara otomatis agar pelanggan mendapat jawaban cepat.",
      },
      {
        icon: "mdi-image-outline",
        title: "Pesan gambar",
        text: "Kirim media dengan caption untuk katalog, bukti transfer, atau panduan visual.",
      },
      {
        icon: "mdi-inbox-arrow-down",
        title: "Inbox terpusat",
        text: "Pantau pesan masuk dan riwayat keluar dari satu tempat yang rapi.",
      },
    ],
    steps: [
      {
        title: "Daftar & hubungkan nomor",
        text: "Buat akun, scan QR WhatsApp, dan pastikan sesi terhubung di Pengaturan.",
      },
      {
        title: "Siapkan kontak atau API key",
        text: "Impor penerima di Kontak, atau integrasikan endpoint kirim ke sistem Anda.",
      },
      {
        title: "Kirim & pantau status",
        text: "Lihat antrian, terkirim, terjadwal, dan balasan masuk langsung di dashboard.",
      },
    ],
    uses: [
      "OTP & verifikasi login",
      "Status pesanan e-commerce",
      "Reminder jadwal & tagihan",
      "Broadcast promo terbatas",
      "CS auto reply 24 jam",
      "Notifikasi internal tim",
    ],
  }),
  computed: {
    ...mapState(["device", "page", "http"]),
    isMobile() {
      return this.device && this.device.mobile;
    },
    year() {
      return new Date().getFullYear();
    },
    apiHost() {
      const base = (this.page && this.page.domainUrl) || "https://api.senderwa.com/";
      return String(base).replace(/\/$/, "");
    },
    featuredIndex() {
      if (!this.pakets.length) return -1;
      if (this.pakets.length === 1) return 0;
      return Math.min(1, this.pakets.length - 1);
    },
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll, { passive: true });
    this.onScroll();
    document.title = "SenderWA — WhatsApp Gateway";
    this.fetchPakets();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    onScroll() {
      this.scrolled = window.scrollY > 24;
    },
    scrollTo(id) {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    },
    isFeaturedPaket(i) {
      return i === this.featuredIndex;
    },
    formatPriceNumber(value) {
      const num = Number(value);
      if (Number.isNaN(num)) return value || "0";
      return new Intl.NumberFormat("id-ID", {
        maximumFractionDigits: 0,
      }).format(num);
    },
    async fetchPakets() {
      this.paketsLoading = true;
      try {
        // tunggu axios store siap (setPage di Base.vue)
        for (let i = 0; i < 20 && !this.http; i++) {
          await new Promise((r) => setTimeout(r, 100));
        }
        if (!this.http) {
          this.pakets = [];
          return;
        }
        const { data } = await this.http.get("pakets");
        this.pakets = Array.isArray(data) ? data : [];
      } catch (e) {
        this.pakets = [];
      } finally {
        this.paketsLoading = false;
      }
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Figtree:wght@400;500;600;700&family=Syne:wght@600;700;800&display=swap");

.lp {
  --ink: #0c2219;
  --forest: #0a3d2e;
  --leaf: #1a6b4d;
  --mint: #8fd6b5;
  --fog: #e8f3ed;
  --paper: #f4faf7;
  --line: #c5d9ce;
  --muted: #5a7266;
  --cream: #f7fbf9;
  font-family: "Figtree", "Montserrat", sans-serif;
  color: var(--ink);
  background: var(--cream);
  min-height: 100vh;
  overflow-x: hidden;
}

/* NAV */
.lp-nav {
  position: fixed;
  inset: 0 0 auto 0;
  z-index: 40;
  transition: background 0.35s ease, box-shadow 0.35s ease, backdrop-filter 0.35s ease;
}

.lp-nav.is-scrolled {
  background: rgba(244, 250, 247, 0.92);
  backdrop-filter: blur(12px);
  box-shadow: 0 1px 0 var(--line);
}

.lp-nav__inner {
  max-width: 1120px;
  margin: 0 auto;
  padding: 1rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.lp-brand {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  text-decoration: none;
  color: inherit;
}

.lp-brand__mark {
  width: 12px;
  height: 12px;
  border-radius: 4px;
  background: linear-gradient(145deg, var(--mint), var(--leaf));
  box-shadow: 0 0 0 4px rgba(31, 122, 87, 0.12);
}

.lp-brand__name {
  font-family: "Syne", "Montserrat", sans-serif;
  font-weight: 800;
  font-size: 1.15rem;
  letter-spacing: -0.02em;
  color: var(--forest);
}

.lp-nav.is-scrolled .lp-brand__name {
  color: var(--forest);
}

.lp-nav:not(.is-scrolled) .lp-brand__name,
.lp-nav:not(.is-scrolled) .lp-nav__links a,
.lp-nav:not(.is-scrolled) .lp-link-quiet {
  color: #f4fbf7;
}

.lp-nav__links {
  display: flex;
  gap: 1.5rem;
}

.lp-nav__links a {
  text-decoration: none;
  font-weight: 600;
  font-size: 0.92rem;
  color: var(--forest);
  opacity: 0.9;
}

.lp-nav__actions {
  display: flex;
  align-items: center;
  gap: 0.85rem;
}

.lp-link-quiet {
  text-decoration: none;
  font-weight: 600;
  font-size: 0.92rem;
  color: var(--forest);
}

/* BUTTONS */
.lp-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.85rem 1.35rem;
  border-radius: 10px;
  font-weight: 700;
  font-size: 0.95rem;
  text-decoration: none;
  letter-spacing: -0.01em;
  transition: transform 0.25s ease, background 0.25s ease, color 0.25s ease;
}

.lp-btn:hover {
  transform: translateY(-2px);
}

.lp-btn--primary {
  background: linear-gradient(145deg, #b7ebcf, #8fd6b5);
  color: #0b3d2e;
}

.lp-btn--ghost {
  background: transparent;
  color: #f4fbf7;
  border: 1px solid rgba(244, 251, 247, 0.35);
}

.lp-btn--ghost-light {
  background: transparent;
  color: #f4fbf7;
  border: 1px solid rgba(244, 251, 247, 0.4);
}

.lp-btn--nav {
  padding: 0.55rem 1rem;
  background: linear-gradient(145deg, #b7ebcf, #8fd6b5);
  color: #0b3d2e;
}

.lp-nav:not(.is-scrolled) .lp-btn--nav {
  background: rgba(244, 251, 247, 0.14);
  color: #f4fbf7;
  border: 1px solid rgba(244, 251, 247, 0.28);
}

.lp-nav.is-scrolled .lp-btn--nav {
  background: linear-gradient(145deg, #b7ebcf, #8fd6b5);
  color: #0b3d2e;
  border: none;
}

/* HERO */
.lp-hero {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: flex-end;
  padding: 7rem 1.5rem 4.5rem;
  color: #f4fbf7;
  overflow: hidden;
}

.lp-hero__bg {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(90% 70% at 85% 20%, rgba(143, 214, 181, 0.28), transparent 55%),
    linear-gradient(165deg, #06281f 0%, #0d4a36 42%, #0a3327 100%);
}

.lp-hero__wash {
  position: absolute;
  inset: 0;
  background: radial-gradient(60% 50% at 20% 80%, rgba(26, 107, 77, 0.45), transparent 70%);
  animation: lpDrift 14s ease-in-out infinite alternate;
}

.lp-hero__signal {
  position: absolute;
  width: 55vmax;
  height: 55vmax;
  right: -12%;
  top: -18%;
  border-radius: 50%;
  border: 1px solid rgba(143, 214, 181, 0.15);
  animation: lpPulse 8s ease-in-out infinite;
}

.lp-hero__signal::before,
.lp-hero__signal::after {
  content: "";
  position: absolute;
  inset: 12%;
  border-radius: 50%;
  border: 1px solid rgba(143, 214, 181, 0.12);
}

.lp-hero__signal::after {
  inset: 24%;
}

.lp-hero__grid {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0.9;
}

.lp-hero__device {
  position: absolute;
  right: 8%;
  bottom: 8%;
  width: min(280px, 34vw);
  animation: lpFloat 6s ease-in-out infinite;
}

.lp-phone {
  background: #10241c;
  border-radius: 28px;
  padding: 12px 10px 16px;
  border: 1px solid rgba(143, 214, 181, 0.25);
  transform: rotate(-6deg);
}

.lp-phone__notch {
  width: 36%;
  height: 8px;
  margin: 0 auto 12px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.08);
}

.lp-phone__screen {
  background: #0a3327;
  border-radius: 18px;
  padding: 14px 12px;
  min-height: 280px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.lp-bubble {
  max-width: 88%;
  padding: 0.55rem 0.75rem;
  border-radius: 12px;
  font-size: 0.72rem;
  line-height: 1.35;
  animation: lpBubbleIn 0.6s ease both;
}

.lp-bubble--in {
  align-self: flex-start;
  background: rgba(143, 214, 181, 0.16);
  color: #d9f2e5;
}

.lp-bubble--out {
  align-self: flex-end;
  background: #1f7a57;
  color: #f4fbf7;
}

.lp-bubble--in:nth-child(1) { animation-delay: 0.2s; }
.lp-bubble--out:nth-child(2) { animation-delay: 0.55s; }
.lp-bubble--in:nth-child(3) { animation-delay: 0.9s; }
.lp-bubble--typing { animation-delay: 1.25s; display: inline-flex; gap: 4px; padding: 0.7rem 0.85rem; }

.lp-bubble--typing span {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: rgba(244, 251, 247, 0.7);
  animation: lpDot 1.2s ease-in-out infinite;
}

.lp-bubble--typing span:nth-child(2) { animation-delay: 0.15s; }
.lp-bubble--typing span:nth-child(3) { animation-delay: 0.3s; }

.lp-hero__content {
  position: relative;
  z-index: 2;
  max-width: 640px;
  margin-left: max(0px, calc((100% - 1120px) / 2));
}

.lp-brand-hero {
  font-family: "Syne", "Montserrat", sans-serif;
  font-weight: 800;
  font-size: clamp(2.6rem, 7vw, 4.4rem);
  letter-spacing: -0.04em;
  line-height: 0.95;
  margin-bottom: 1.1rem;
  color: #f4fbf7;
}

.lp-hero__title {
  font-family: "Syne", "Montserrat", sans-serif;
  font-weight: 700;
  font-size: clamp(1.35rem, 3.2vw, 1.85rem);
  line-height: 1.25;
  letter-spacing: -0.02em;
  max-width: 18ch;
  margin: 0 0 1rem;
  color: rgba(244, 251, 247, 0.92);
}

.lp-hero__lead {
  font-size: 1.05rem;
  line-height: 1.55;
  color: rgba(244, 251, 247, 0.72);
  max-width: 38ch;
  margin: 0 0 1.75rem;
}

.lp-hero__cta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

/* SECTIONS */
.lp-section {
  padding: 5.5rem 1.5rem;
}

.lp-section--fog {
  background: var(--fog);
}

.lp-section__inner {
  max-width: 1120px;
  margin: 0 auto;
}

.lp-eyebrow {
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--leaf);
  margin: 0 0 0.75rem;
}

.lp-h2 {
  font-family: "Syne", "Montserrat", sans-serif;
  font-weight: 700;
  font-size: clamp(1.7rem, 3.5vw, 2.35rem);
  letter-spacing: -0.03em;
  line-height: 1.15;
  color: var(--forest);
  margin: 0 0 0.85rem;
  max-width: 18ch;
}

.lp-lead {
  font-size: 1.05rem;
  color: var(--muted);
  line-height: 1.55;
  max-width: 42ch;
  margin: 0 0 2.75rem;
}

.lp-features {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem 1.75rem;
}

.lp-feature {
  padding-top: 0.25rem;
  animation: lpRise 0.7s ease both;
  animation-delay: calc(var(--i) * 0.08s);
}

.lp-feature__icon {
  width: 42px;
  height: 42px;
  display: grid;
  place-items: center;
  border-radius: 10px;
  background: linear-gradient(145deg, #d8f3e5, #b7ebcf);
  margin-bottom: 0.85rem;
}

.lp-feature__icon .v-icon {
  color: var(--forest) !important;
}

.lp-feature h3 {
  font-family: "Syne", sans-serif;
  font-size: 1.1rem;
  font-weight: 700;
  margin: 0 0 0.4rem;
  color: var(--ink);
}

.lp-feature p {
  margin: 0;
  color: var(--muted);
  line-height: 1.5;
  font-size: 0.95rem;
}

/* PRICING */
.lp-pricing {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.25rem;
  align-items: stretch;
}

.lp-pricing__state {
  color: var(--muted);
  font-weight: 600;
  padding: 1.5rem 0;
}

.lp-price {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 1.5rem 1.35rem 1.4rem;
  border-radius: 16px;
  background: #fff;
  border: 1px solid var(--line);
  animation: lpRise 0.7s ease both;
  animation-delay: calc(var(--i) * 0.08s);
}

.lp-price.is-featured {
  background:
    radial-gradient(120% 80% at 0% 0%, rgba(143, 214, 181, 0.35), transparent 55%),
    linear-gradient(175deg, #0b3d2e 0%, #0f5c45 55%, #0a3327 100%);
  border-color: transparent;
  color: #f4fbf7;
  transform: translateY(-6px);
}

.lp-price__badge {
  position: absolute;
  top: 1rem;
  right: 1rem;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 0.25rem 0.55rem;
  border-radius: 6px;
  background: linear-gradient(145deg, #b7ebcf, #8fd6b5);
  color: #0b3d2e;
}

.lp-price__name {
  font-family: "Syne", sans-serif;
  font-weight: 700;
  font-size: 1.25rem;
  margin: 0 0 0.4rem;
  color: var(--ink);
}

.lp-price.is-featured .lp-price__name {
  color: #f4fbf7;
}

.lp-price__desc {
  margin: 0 0 1.15rem;
  color: var(--muted);
  font-size: 0.9rem;
  line-height: 1.45;
  min-height: 2.7em;
}

.lp-price.is-featured .lp-price__desc {
  color: rgba(244, 251, 247, 0.72);
}

.lp-price__amount {
  display: flex;
  align-items: baseline;
  gap: 0.35rem;
  margin-bottom: 1.25rem;
}

.lp-price__currency {
  font-weight: 700;
  font-size: 0.95rem;
  color: var(--leaf);
}

.lp-price.is-featured .lp-price__currency {
  color: var(--mint);
}

.lp-price__value {
  font-family: "Syne", sans-serif;
  font-weight: 800;
  font-size: clamp(1.7rem, 3vw, 2.1rem);
  letter-spacing: -0.03em;
  color: var(--forest);
  line-height: 1;
}

.lp-price.is-featured .lp-price__value {
  color: #f4fbf7;
}

.lp-price__features {
  list-style: none;
  padding: 0;
  margin: 0 0 1.4rem;
  flex: 1;
}

.lp-price__features li {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--ink);
  margin-bottom: 0.55rem;
}

.lp-price.is-featured .lp-price__features li {
  color: rgba(244, 251, 247, 0.9);
}

.lp-price__features li.is-off {
  opacity: 0.45;
  font-weight: 500;
}

.lp-price__features .v-icon {
  color: var(--leaf) !important;
}

.lp-price.is-featured .lp-price__features .v-icon {
  color: var(--mint) !important;
}

.lp-price__features li.is-off .v-icon {
  color: var(--muted) !important;
}

.lp-price .lp-btn {
  width: 100%;
}

.lp-btn--outline {
  background: transparent;
  color: var(--forest);
  border: 1px solid var(--line);
}

.lp-btn--outline:hover {
  border-color: var(--leaf);
  background: rgba(143, 214, 181, 0.12);
}

.lp-steps {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 1.5rem;
}

.lp-steps li {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 1.15rem;
  align-items: start;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid var(--line);
}

.lp-steps li:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.lp-steps__num {
  font-family: "Syne", sans-serif;
  font-weight: 800;
  font-size: 1.5rem;
  color: var(--leaf);
  line-height: 1;
  min-width: 2rem;
}

.lp-steps h3 {
  margin: 0 0 0.35rem;
  font-family: "Syne", sans-serif;
  font-size: 1.15rem;
}

.lp-steps p {
  margin: 0;
  color: var(--muted);
  line-height: 1.5;
}

.lp-api {
  display: grid;
  grid-template-columns: 1fr 1.05fr;
  gap: 3rem;
  align-items: center;
}

.lp-checklist {
  list-style: none;
  padding: 0;
  margin: 1.5rem 0 0;
}

.lp-checklist li {
  position: relative;
  padding-left: 1.35rem;
  margin-bottom: 0.55rem;
  color: var(--ink);
  font-weight: 600;
}

.lp-checklist li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0.45rem;
  width: 0.55rem;
  height: 0.55rem;
  border-radius: 2px;
  background: var(--leaf);
}

.lp-code {
  background: #0a3327;
  color: #d9f2e5;
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid rgba(143, 214, 181, 0.2);
}

.lp-code__bar {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0.75rem 1rem;
  background: rgba(0, 0, 0, 0.25);
  border-bottom: 1px solid rgba(143, 214, 181, 0.12);
}

.lp-code__bar span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(143, 214, 181, 0.35);
}

.lp-code__bar em {
  margin-left: auto;
  font-style: normal;
  font-size: 0.75rem;
  color: rgba(217, 242, 229, 0.55);
}

.lp-code pre {
  margin: 0;
  padding: 1.15rem 1.25rem 1.4rem;
  overflow-x: auto;
  font-size: 0.82rem;
  line-height: 1.55;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
}

.lp-uses {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.lp-use {
  padding: 0.7rem 1rem;
  border: 1px solid var(--line);
  border-radius: 10px;
  background: #fff;
  font-weight: 600;
  color: var(--forest);
  font-size: 0.92rem;
}

.lp-cta {
  padding: 5rem 1.5rem;
  background:
    radial-gradient(80% 80% at 100% 0%, rgba(143, 214, 181, 0.22), transparent 50%),
    linear-gradient(160deg, #0a3d2e, #0d4a36 55%, #06281f);
  color: #f4fbf7;
}

.lp-cta__inner {
  max-width: 720px;
  margin: 0 auto;
  text-align: left;
}

.lp-cta h2 {
  font-family: "Syne", sans-serif;
  font-size: clamp(1.7rem, 3.5vw, 2.4rem);
  letter-spacing: -0.03em;
  margin: 0 0 0.85rem;
  max-width: 16ch;
}

.lp-cta p {
  margin: 0 0 1.75rem;
  color: rgba(244, 251, 247, 0.72);
  max-width: 40ch;
  line-height: 1.55;
}

.lp-footer {
  padding: 2.5rem 1.5rem 3rem;
  background: #06281f;
  color: rgba(244, 251, 247, 0.7);
}

.lp-footer__inner {
  max-width: 1120px;
  margin: 0 auto;
}

.lp-footer .lp-brand__name {
  color: #f4fbf7;
}

.lp-footer p {
  margin: 0.75rem 0 1.5rem;
  max-width: 36ch;
  font-size: 0.92rem;
}

.lp-footer__meta {
  display: flex;
  gap: 1.25rem;
  align-items: center;
  font-size: 0.85rem;
}

.lp-footer__meta a {
  color: var(--mint);
  text-decoration: none;
  font-weight: 600;
}

@keyframes lpDrift {
  from { transform: translate3d(0, 0, 0); }
  to { transform: translate3d(-2%, 3%, 0); }
}

@keyframes lpPulse {
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.04); opacity: 0.85; }
}

@keyframes lpFloat {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

@keyframes lpBubbleIn {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes lpDot {
  0%, 80%, 100% { opacity: 0.35; transform: translateY(0); }
  40% { opacity: 1; transform: translateY(-3px); }
}

@keyframes lpRise {
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
}

@media (max-width: 960px) {
  .lp-features {
    grid-template-columns: 1fr 1fr;
  }
  .lp-pricing {
    grid-template-columns: 1fr 1fr;
  }
  .lp-price.is-featured {
    transform: none;
  }
  .lp-api {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
  .lp-hero__device {
    opacity: 0.35;
    right: -4%;
    bottom: 18%;
  }
  .lp-hero__content {
    margin-left: 0;
  }
}

@media (max-width: 600px) {
  .lp-hero {
    align-items: center;
    padding: 6.5rem 1.15rem 3.5rem;
  }
  .lp-hero__device {
    display: none;
  }
  .lp-features {
    grid-template-columns: 1fr;
  }
  .lp-pricing {
    grid-template-columns: 1fr;
  }
  .lp-brand-hero {
    font-size: 2.5rem;
  }
  .lp-hero__title {
    max-width: none;
  }
  .lp-nav__inner {
    padding: 0.85rem 1rem;
  }
  .lp-section {
    padding: 4rem 1.15rem;
  }
}
</style>
